import { Meta } from '@/components/common';
import { IssueQueue, RaiseIssueForm } from '@/components/features/support';
import { Container } from '@/components/layout';

/**
 * Support, laid out as the design draws it.
 *
 * ── Why the form is always open ─────────────────────────────────────────────
 *
 * It used to be collapsed behind a "Raise an issue" button, on the reasoning
 * that most visits are to check on something already raised. The design puts
 * the form at the top of the screen, unfolded, and that is the better call:
 * somebody arriving with a new problem is the person in the worse state, and
 * making them find a button first is one more thing between them and telling
 * us. The queue is directly underneath and loses nothing by it.
 *
 * There is no page heading. The shell's 80px header carries the screen name
 * already, and a second "Support" under it is the kind of duplication that
 * makes a page look untidy without anybody being able to say why.
 */
export function IssuesPage() {
  return (
    <>
      <Meta title="Support" />

      <Container className="space-y-3.5">
        <RaiseIssueForm />
        <IssueQueue />
      </Container>
    </>
  );
}
